import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },

  icon: {
    fontSize: theme.spacing(22.5),
    color: theme.palette.primary.light,
  },

  warningMessage: {
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(2),
    maxWidth: theme.spacing(50),
    textAlign: 'center',
  },

  button: {
    '&.MuiButton-root': {
      textTransform: 'capitalize',
    },
  },
}));
